import React from 'react'

class ReportRemover extends React.Component{

	constructor(props){
		super(props);

		this.urlField=React.createRef();
		this.emailField=React.createRef();
	}

	register=()=>{
	    var body={
	        context:{
	            pageUri: window.location.href,
	            pageName: "Delete scan report"
	        },
	        fields: [
	            {  
	                name: "website",
	                value: this.urlField.value
	            },
	            {
	                name: "email",
	                value: this.emailField.value
	            },
	            {
	                name: "project",
	                value: window.location.href
	            },
	            {
	                name: "production",
	                value: (window.location.origin.includes("qa") || (window.location.origin.includes("local")))?false:true
	            }
	        ]
	    }
	    var params={
	        method: 'POST',
	        headers:{
	            'Content-type': 'application/json'
	        },
	        body: JSON.stringify(body)
	    }
	    var hubspotId="6097656/cb327e7f-4cb0-47a5-99fe-0c0d23776f28/";

	    fetch('https://api.hsforms.com/submissions/v3/integration/submit/'+hubspotId,params)
	    .then(response=>response.json())
	    .then(data=>{
	        window.$("#delete-report-modal").modal('toggle'); 
	            setTimeout(function(){
	                window.$("#delete-request-modal").modal('toggle');
	        },800);
	    })
	}

	render(){
		return(
			<div className="modal fade" id="delete-report-modal" >
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h4 className="modal-title">Do you want this report to be deleted?</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						<div className="modal-body" id="delete-report-text">
							Deletion requests submitted to Meterian will be deleted within 6 months as per our data handling terms (<a href="https://www.meterian.com/gdpr.html" target="_blank" rel="noopener noreferrer">https://www.meterian.com/gdpr.html</a>).
							<br />
							<br />
	
						</div>
						<div className="modal-footer ">
							<div id="form-delete-report">
								<input type="hidden" name="EMAIL" id="mce-EMAIL" ref={this.emailField} value="" />
								<input type="hidden" name="URL" id="mce-URL" ref={this.urlField} value="" />
							</div>
							<p className="footer-delete-text">Submit your deletion request now?</p>
							<p className="footer-buttons">
								<button type="button" className="btn btn-secondary m-1" id="send-delete-request" onClick={this.register}>Yes</button>
								<button type="button" data-dismiss="modal" className="btn btn-secondary m-1">No</button>
							</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ReportRemover